import FlightAnimation from "./flight-animation";
export default function ItemHitPhysics(level, physics) {
  const {
    player,
    grid
  } = level;
  const {
    position,
    size
  } = player;
  const {
    width,
    height
  } = size;
  const pos = {
    x: position.x + width / 2,
    y: position.y + height - 5
  };
  const gridPos = grid.levelToGrid(pos);
  const {
    x,
    y
  } = gridPos;
  const item = grid.getItem(x, y);
  if (!item) return;
  if (!item?.params?.collectable) return;
  switch (item?.params?.effect) {
    case "inventory":
      const {
        name
      } = item;
      if (!(name in player.items)) player.items[name] = 0;
      player.items[name]++;
      physics.animations.add(FlightAnimation(item, level.levelToScreen(grid.gridToLevel(gridPos))));
      grid.setItem(x, y, null);
      break;
    case "endGame":
      level.end();
      break;
  }
}